import api from "@services/api";

function getExportacoes() {
  return api.get("/exportacao");
}

const exportacaoService = {
  getExportacoes: getExportacoes,
};

export default exportacaoService;
